import React from "react"
import { BasicTableSeeker } from "@ui-seeker/core"

import AppBasicTableLegend from "./Legend"
import AppTitleWithPopup from "../TitleWithPopup"


export default function AppBasicTable(
	{
		data = [],
		title = '',
		titleProps = {},
		headers = [],
		columns = [],
		Components = {},
		legend,
		...props
	}) {

	const conditionalProps = {
		...legend && { footer: <AppBasicTableLegend items={legend}/> }
	}

	return <BasicTableSeeker
		toolbarProps={{ actions: false }}
		data={data}
		title={Components?.Title ? <Components.Title title={title}/> :
			<AppTitleWithPopup title={title} {...titleProps} />}
		headers={headers}
		setHeaderRowsProps={() => ({
			sx: {
				backgroundColor: 'primary.main',
			}
		})}
		setHeaderCellProps={() => ({
			sx: {
				backgroundColor: 'primary.main',
			}
		})}
		setBodyRowsProps={(rowData, idx) => {
			return {
				sx: {
					backgroundColor: idx % 2 === 0 ? "background.grey" : "background.lightGrey",
				}
			}
		}}
		columns={columns}
		{...conditionalProps}
		{...props}
	/>
}